export default function(h, row, index) {
    let _from = ''
    if (row.date_begin_iso != null)
        _from = row.date_begin_iso.substring(0,10);
    let _to = ''
    if (row.date_end_iso != null)
        _to = row.date_end_iso.substring(0,10);
    if (row.date_begin_iso != null)
        return <span><span class='nobr' title='Заезд'><b>З:</b> {_from}</span><br/><span class='nobr' title='Выезд'><b>В:</b> {_to}</span></span>
    else
        return null
}